import PocketBase from 'pocketbase';

// PocketBase instance
// В разработке: http://127.0.0.1:8090
// В продакшене: https://pb.sense-games.ru (или ваш домен)
const PB_URL = process.env.REACT_APP_POCKETBASE_URL;

export const pb = new PocketBase(PB_URL);

// Автоматически обновляем токен при его истечении
pb.autoCancellation(false);

// Хелпер: получить текущего пользователя
export function getCurrentUser() {
    return pb.authStore.model;
}

// Хелпер: проверить авторизацию
export function isAuthenticated() {
    return pb.authStore.isValid;
}

// Хелпер: получить токен
export function getAuthToken() {
    return pb.authStore.token;
}

// Хелпер: выйти из аккаунта
export function logout() {
    pb.authStore.clear();
}

// Хелпер: получить URL файла
export function getFileUrl(record, filename, thumb = null) {
    if (!record || !filename) return null;

    const options = thumb ? { thumb } : {};
    return pb.files.getURL(record, filename, options);
}

// Хелпер: подписаться на изменения авторизации
export function onAuthChange(callback) {
    return pb.authStore.onChange(callback);
}

// API wrapper для custom endpoints
export async function customApi(method, path, body = null) {
    const url = `${PB_URL}${path}`;
    const headers = {
        'Content-Type': 'application/json',
    };

    if (pb.authStore.token) {
        headers['Authorization'] = pb.authStore.token;
    }

    const options = {
        method,
        headers,
    };

    if (body && method !== 'GET') {
        options.body = JSON.stringify(body);
    }

    const response = await fetch(url, options);
    const data = await response.json();

    if (!response.ok) {
        throw new Error(data.error || 'API request failed');
    }

    return data;
}

export default pb;
